import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useAnnouncement(id: string | undefined) {
  return useQuery({
    queryKey: ['announcement', id],
    enabled: !!id,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('announcements')
        .select(`
          id, title, body, priority, category, image_storage_path,
          published_at,
          author_entity:entities!announcements_author_entity_id_fkey(name)
        `)
        .eq('id', id!)
        .single()

      if (error) throw error

      let image_url: string | null = null
      if (data.image_storage_path) {
        const { data: signed } = await supabase.storage
          .from('announcement-images')
          .createSignedUrl(data.image_storage_path, 3600)
        image_url = signed?.signedUrl ?? null
      }

      return {
        ...data,
        image_url,
        author_entity_name: (data.author_entity as any)?.name ?? 'Local Authority',
      }
    },
  })
}
